import { log } from 'console';
import { Error } from './../transaction-verification/transaction-verification.model';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { OigService } from './oig.service';
import { Router } from '@angular/router';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { exportPDF, Group } from '@progress/kendo-drawing';
import { getOigListeBase, matchedEMPBO } from './oig-model';
import { getOigHTTPService } from './oig-dataService';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-oig',
  templateUrl: './oig.component.html',
  styleUrls: ['./oig.component.scss']
})
export class OigComponent implements OnInit {
   
  @ViewChild("gridLEIELog") public gridLEIELog: GridComponent;
  private onDestroy$: Subject<void> = new Subject<void>();
  leieuploadlog:any;
  initialPage: PageSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public filterSettings: object;
  file:any;
  FileName:any;
  selected: boolean = false;
  @ViewChild('pdfLEIE') pdfLEIE;
  selectedFile: any = null;
  selectedFileName: string = "";
  public formatOptions: object;
 
  constructor(private router:Router,private oigService:OigService,private toast:ToastrService,public global: GlobalComponent,
    @Inject(getOigHTTPService) public getOigReport: getOigHTTPService,
    ) { 

      this.leieuploadlog = getOigReport;
    }

  ngOnInit(): void {
    this.global.checkforlogout();
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") 
     {
      return;
    }

    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };

    this.filterSettings = {
      type: "Menu",
    };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };

    this.getOigAnalysisData();

  }

  

onDOCFileChanged(files) {
  console.log(files,'files')
  let val = files.item(0);
  const formData: FormData = new FormData();
  formData.append("file", val, val.name.toString());
  //this.purchaseBO.attachMent = files.item(0);
  this.file = files.item(0);
}
getOigAnalysisData(){
  this.getOigReport.execute(this.getOigDataList);
  let count = 0;
  this.leieuploadlog.pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=> {
      count =+ 1;
      console.log(count)
  })

}


  /*********************************************************************************************************************** */
 
  uploadLEIEFile(){
    console.log('uploded')
    let body = new FormData();
    body.append('File', this.file, this.FileName);
    this.oigService.uploadLEIE(body).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
         this.toast.success("Data imported successfully, Please Check After few minutes", "Successful");
         this.getOigAnalysisData()
         this.file=[]
         this.FileName=[];
         this.selected = false
    },
   (err:any) =>
    {
      this.toast.error(err.Error,'error')
    })

  }



  getOigDataList:getOigListeBase = new getOigListeBase()
  public dataStateChange(M): void {
    let val = M.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.getOigDataList.orderColumn = M.sorted[0].name;
        this.getOigDataList.orderType =
          M.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.getOigDataList.value = M.action.currentFilterObject.value;
      this.getOigDataList.field = M.action.currentFilterObject.field;
      this.getOigDataList.matchCase = M.action.currentFilterObject.matchCase;
      this.getOigDataList.operator = M.action.currentFilterObject.operator;
      if (this.getOigDataList.type == "number") {
        this.getOigDataList.value =
          M.action.currentFilterObject.value.toString();
        this.getOigDataList.field = M.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && M.action.action == "clearFilter") {
        this.getOigDataList.field = "importedBy";
        this.getOigDataList.matchCase = false;
        this.getOigDataList.operator = "contains";
        this.getOigDataList.value = "";
        this.getOigDataList.type = "string";
      }
    }
    this.getOigAnalysisData();

    if (val == "paging" && M.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }


  onActionComplete(s){
    this.getOigDataList.currentpageno =
    this.gridLEIELog.pagerModule.pagerObj.currentPage;
  this.getOigDataList.pageitem = this.gridLEIELog.pagerModule.pagerObj.pageSize;
  if (s.name == "actionBegin" && s.requestType == "filterbeforeopen") {
    this.getOigDataList.type = s.columnType;
  }
  }

  validatebutton(s){

  }

  onResize(S){

  }

  backToDashboard(){
    this.router.navigateByUrl('/operational-dashboard')
  }

  printLEIE() {
    this.pdfLEIE.A4 = true,
      this.pdfLEIE.portrait = true,
      this.pdfLEIE.keepTogether = ".prevent-split",
      this.pdfLEIE.scale = 0.8,
      this.pdfLEIE.forcePageBreak = ".page-break",
      this.pdfLEIE.export().then((group: Group) => exportPDF(group)).then((dataUri) => {
        const base64 = dataUri.replace('data:application/pdf;base64,', '');
        const fileObject = this.dataURLtoFile(dataUri, 'test');
        var fileurl = URL.createObjectURL(fileObject);
        var d = document.getElementById("printsec");
        var a = window.open(fileurl, '', 'height=500, width=500');
        a.print();
      });
  }

  public dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }



   getMatchEmpBO:matchedEMPBO[]=[]
  getMatchedEmployeeList(data){
      let paramsData = new URLSearchParams();
      paramsData.append('uploadlogid',data.id);
      document.getElementById("MatchedEmployeeModal").click();
    this.oigService.getMatchedEmployee(paramsData).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      console.log(data,'data');
      this.getMatchEmpBO = data;
      console.log(this.getMatchEmpBO,'data');
    })

  }


  printLeie(){
    this.gridLEIELog.print();
  }
}

